module.exports = __webpack_public_path__ + "img/levelStar.c5e63fa0.png";